import { useState } from 'react';
import {
  ButtonMain,
  Card,
  Pagination,
  Table,
} from '@quero-delivery/quero-components-web';
import { getEndOfDay, getStartOfDay } from '@querodelivery/qd-date-helper';

import * as Form from '@radix-ui/react-form';
import { Modal, useMediaQuery } from '@querodelivery/uni-react';

import styles from './extract-list-modal.module.scss';
import { DEFAULT_LIMIT_REQUEST } from '@/Constants';
import { ExtractRowModal } from '../extract-row-modal';
import type { Extract } from '../../types';
import { CalendarInput } from '@/_components/calendar-input/calendar-input';

interface IProps {
  open: boolean;
  onClose: () => void;
  params: {
    startDate: string;
    endDate: string;
  };
  setParams: (params: IProps['params']) => void;
  page: number;
  setPage: (page: number) => void;
  extracts: Extract[];
  totalCount: number;
  isLoading: boolean;
}

function ExtractsListModal({
  open,
  onClose,
  params,
  setParams,
  extracts,
  page,
  setPage,
  totalCount,
  isLoading,
}: IProps) {
  const isMobile = useMediaQuery('lg-down');
  const [startDate, setStartDate] = useState<Date>(
    getStartOfDay(params.startDate),
  );
  const [endDate, setEndDate] = useState<Date>(getEndOfDay(params.endDate));

  const isPlacePage = location.pathname.includes('estabelecimentos');

  function onSearch() {
    setParams({
      startDate: startDate.toISOString(),
      endDate: endDate.toISOString(),
    });
    setPage(1);
  }

  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      header="Extratos"
      variant={isMobile ? 'bottom' : 'floating'}
    >
      <div className={styles.container}>
        <Form.Root className={styles.filterContainer}>
          <CalendarInput
            label="De"
            name="startDate"
            value={startDate}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            onChange={startDate =>
              startDate ? setStartDate(getStartOfDay(startDate)) : undefined
            }
            maxDate={new Date()}
            todayButton="Hoje"
            popperPlacement="top"
          />

          <CalendarInput
            label="Até"
            name="endDate"
            value={endDate}
            selectsStart
            startDate={startDate}
            endDate={endDate}
            onChange={endDate =>
              endDate ? setEndDate(getEndOfDay(endDate)) : undefined
            }
            maxDate={new Date()}
            minDate={startDate}
            todayButton="Hoje"
          />

          <ButtonMain
            textFirst="buscar"
            firstStrong
            type="submit"
            disabled={isLoading}
            onClick={e => {
              e.preventDefault();
              onSearch();
            }}
          />
        </Form.Root>
      </div>

      <Card type="none" className={styles.card} loading={isLoading}>
        <Table
          compact
          textAlign="left"
          pagination={
            <div className="pagination">
              <Pagination
                size="sm"
                limitPerPage={DEFAULT_LIMIT_REQUEST}
                currentPage={page}
                totalCount={totalCount || 0}
                onPageChange={setPage}
              />
            </div>
          }
        >
          <>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Data</Table.HeaderCell>
                <Table.HeaderCell>Valor</Table.HeaderCell>
                <Table.HeaderCell>Saldo</Table.HeaderCell>
                <Table.HeaderCell>Operação</Table.HeaderCell>
                <Table.HeaderCell>Motivos</Table.HeaderCell>
                {isPlacePage && (
                  <Table.HeaderCell>ID transação</Table.HeaderCell>
                )}
                <Table.HeaderCell>Descrição</Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {extracts?.map(extract => (
                <ExtractRowModal key={extract._id} extract={extract} />
              ))}
            </Table.Body>
          </>
        </Table>
      </Card>
    </Modal>
  );
}

export { ExtractsListModal };
